module.exports = __webpack_public_path__ + "static/latte-d1c43f7fee44cca38e0801b49d85423b.png";